import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiServices from "../../service";

const initialState: any = {
  listItems: [],

  activeItem: {},
  loading: false,
  activeItemloading: false,
};
export const getUsersListItems = createAsyncThunk(
  "manageUser/getUsersListItems",
  async (_, { rejectWithValue }) => {
    try {
      const response: any =
        await apiServices.systemManager.manageUsers.getList();
      const { isError, data } = response.data;
      if (isError || !data) {
        return rejectWithValue("Failed to fetch  list");
      }

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

export const getUserDetailById = createAsyncThunk(
  "manageUser/getUserDetailById",
  async (Id: string, { getState, rejectWithValue }) => {
    if (!Id) return rejectWithValue("Invalid  ID");

    // Access the current state
    const state: any = getState();

    const itemList = state.manageUser.listItems;

    // Find the valuation detail by ID in the listItems array
    const itemDetail = itemList.find((item: any) => item.user_id === Id);
    if (itemDetail) {
      return itemDetail; // Return the detail if found
    } else {
      return rejectWithValue("item detail not found in state");
    }
  }
);

export const manageUserSlice = createSlice({
  name: "manageUser",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUsersListItems.pending, (state) => {
        state.loading = true;
        state.listItems = [];
      })
      .addCase(getUsersListItems.fulfilled, (state, action) => {
        state.loading = false;
        state.listItems = action.payload;
      })
      .addCase(getUsersListItems.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching  list:", action.payload);
      })
      .addCase(getUserDetailById.pending, (state) => {
        state.activeItemloading = true;
        state.activeItem = {};
      })
      .addCase(getUserDetailById.fulfilled, (state, action) => {
        state.activeItemloading = false;
        state.activeItem = action.payload;
      })
      .addCase(getUserDetailById.rejected, (state, action) => {
        state.activeItemloading = false;
        console.error("Error fetching  details:", action.payload);
      });
  },
});
export const {} = manageUserSlice.actions;
export default manageUserSlice.reducer;
